import {
  DEFAULT_CURRENT_PAGE,
  DEFAULT_PAGE_SIZE
} from '../../../pages/constants/commonConstants';
import {
  BULK_SCANNING_FLOW,
  BULK_SCREENING_FLOW
} from '../../../pages/constants/nsConstants';
import { NS_SEND_TO_CM_SUCCESS } from '../../actions/ns/investigation';
import {
  FETCH_SEGMENTS,
  FETCH_SEGMENTS_FAIL,
  FETCH_SEGMENTS_SUCCESS,
  PROCEED_SCREENING,
  PROCEED_SCREENING_FAIL,
  PROCEED_SCREENING_SUCCESS,
  SHOW_SCANNING_MODAL,
  SHOW_SCREENING_MODAL,
  STOP_BULK_SCREENING_LOCAL,
  SCAN_UPLOADED_FILE,
  SCAN_UPLOADED_FILE_FAILED,
  SCAN_UPLOADED_FILE_SUCCESS,
  SET_UPLOADED_FILE,
  PROCEED_BULK_SCREENING,
  PROCEED_BULK_SCREENING_FAIL,
  GET_SCREENING_PROGRESS_FAIL,
  GET_SCREENING_PROGRESS_SUCCESS,
  STOP_BULK_SCREENING,
  STOP_BULK_SCREENING_FAIL,
  STOP_BULK_SCREENING_SUCCESS,
  SET_SCREENING_PERCENT,
  RESET_SIGNLE_SCREENING,
  GET_OD_NS_HISTORY_DOWNLOAD_CSV,
  GET_OD_NS_HISTORY_DOWNLOAD_CSV_SUCCESS,
  GET_OD_NS_HISTORY_DOWNLOAD_CSV_FAIL,
  RESET_OD_NS_HISTORY_DOWNLOAD_CSV,
  SELECTED_ALERT_IDS,
  SELECTED_ALERT_FILTERS,
  FETCH_MATCHING_CONFIGS,
  FETCH_MATCHING_CONFIGS_FAIL,
  FETCH_MATCHING_CONFIGS_SUCCESS,
  UPDATE_ALERT_LIST_PAGE,
  UPDATE_ALERT_LIST_PAGE_SIZE
} from '../../actions/ns/onDemandScreening';

export const initialState = {
  singleScreening: {
    segments: [],
    isLoading: false,
    isSingleScreeningSuccess: false,
    alertId: null,
    hasScreeningError: false,
    hasError: false,
    errorMessage: ''
  },
  bulkScreening: {
    bulkScreeningStarted: false,
    isShowScanModal: false,
    isShowScreenModal: false,
    currentScreeningState: '',
    uploadedFile: null,
    screeningPercent: 0,
    totalCount: 0,
    invalidData: [],
    jobId: null,
    stopScreeningCalled: false,
    screenedRecordCount: 0,
    errorMessage: ''
  },
  alertHistory: { csvData: null, isLoading: false, hasError: false },
  alertList: {
    currentPage: DEFAULT_CURRENT_PAGE,
    pageSize: DEFAULT_PAGE_SIZE,
    selectedIds: [],
    selectedAlerts: [],
    filters: {
      alertLevel: '',
      sortOrder: 'desc',
      searchValue: '',
      alertStatus: undefined,
      segmentName: undefined,
      alertScore: [],
      refreshCount: 0 // To refresh the alert list, update this value after send to cm api.
    }
  },
  matchingConfigs: {
    isLoading: false,
    data: [],
    hasError: false,
    errorMessage: ''
  }
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_SEGMENTS:
      return {
        ...state,
        singleScreening: {
          ...state.singleScreening,
          isLoading: true,
          hasScreeningError: false,
          hasError: false
        }
      };
    case FETCH_SEGMENTS_SUCCESS:
      return {
        ...state,
        singleScreening: {
          ...state.singleScreening,
          isLoading: false,
          segments: payload
        }
      };
    case FETCH_SEGMENTS_FAIL:
      return {
        ...state,
        singleScreening: {
          ...state.singleScreening,
          isLoading: false,
          hasError: true,
          errorMessage: payload
        }
      };
    case PROCEED_SCREENING:
      return {
        ...state,
        singleScreening: {
          ...state.singleScreening,
          isLoading: true,
          hasScreeningError: false,
          isSingleScreeningSuccess: false,
          alertId: null
        }
      };
    case PROCEED_SCREENING_SUCCESS:
      return {
        ...state,
        singleScreening: {
          ...state.singleScreening,
          isLoading: false,
          alertId: payload.alertId,
          isSingleScreeningSuccess: true
        }
      };
    case PROCEED_SCREENING_FAIL:
      return {
        ...state,
        singleScreening: {
          ...state.singleScreening,
          isLoading: false,
          hasScreeningError: true,
          errorMessage: payload
        }
      };
    case RESET_SIGNLE_SCREENING:
      return {
        ...state,
        singleScreening: {
          ...state.singleScreening,
          isSingleScreeningSuccess: false
        }
      };
    case SET_UPLOADED_FILE:
      return {
        ...state,
        bulkScreening: {
          ...state.bulkScreening,
          uploadedFile: payload
        }
      };
    case SHOW_SCANNING_MODAL:
      return {
        ...state,
        bulkScreening: {
          ...state.bulkScreening,
          isShowScanModal: payload
        }
      };
    case SHOW_SCREENING_MODAL:
      return {
        ...state,
        bulkScreening: {
          ...state.bulkScreening,
          isShowScreenModal: payload
        }
      };
    case STOP_BULK_SCREENING_LOCAL:
      return {
        ...state,
        bulkScreening: {
          ...state.bulkScreening,
          bulkScreeningStarted: false,
          isShowScanModal: false,
          isShowScreenModal: false,
          currentScreeningState: '',
          totalCount: 0,
          invalidData: [],
          screeningPercent: 0,
          jobId: null,
          screenedRecordCount: 0
        }
      };
    case SCAN_UPLOADED_FILE:
      return {
        ...state,
        bulkScreening: {
          ...state.bulkScreening,
          bulkScreeningStarted: true,
          isShowScanModal: true,
          isShowScreenModal: false,
          totalCount: 0,
          invalidData: [],
          screeningPercent: 1,
          jobId: null,
          currentScreeningState: BULK_SCANNING_FLOW.SCAN
        }
      };
    case SCAN_UPLOADED_FILE_SUCCESS:
      return {
        ...state,
        bulkScreening: {
          ...state.bulkScreening,
          ...(state.bulkScreening.bulkScreeningStarted
            ? {
                jobId: payload.jobId,
                totalCount: payload.totalCount,
                invalidData: payload.invalidData,
                screeningPercent: 100,
                currentScreeningState: BULK_SCANNING_FLOW.SCAN_SUCCESS
              }
            : {})
        }
      };
    case SCAN_UPLOADED_FILE_FAILED:
      return {
        ...state,
        bulkScreening: {
          ...state.bulkScreening,
          ...(state.bulkScreening.bulkScreeningStarted
            ? {
                errorMessage: payload,
                currentScreeningState: BULK_SCANNING_FLOW.SCAN_FAILED
              }
            : {})
        }
      };
    case PROCEED_BULK_SCREENING:
      return {
        ...state,
        bulkScreening: {
          ...state.bulkScreening,
          isShowScanModal: false,
          isShowScreenModal: true,
          screeningPercent: 0,
          screenedRecordCount: 0,
          currentScreeningState: BULK_SCREENING_FLOW.SCREEN
        }
      };
    case PROCEED_BULK_SCREENING_FAIL:
      return {
        ...state,
        bulkScreening: {
          ...state.bulkScreening,
          errorMessage: payload,
          currentScreeningState: BULK_SCREENING_FLOW.SCREEN_FAILED
        }
      };
    case GET_SCREENING_PROGRESS_SUCCESS:
      return {
        ...state,
        bulkScreening: {
          ...state.bulkScreening,
          stopScreeningCalled: false,
          screenedRecordCount: payload.screenedRecordCount,
          currentScreeningState: BULK_SCREENING_FLOW.SCREEN_SUCCESS
        }
      };
    case GET_SCREENING_PROGRESS_FAIL:
      return {
        ...state,
        bulkScreening: {
          ...state.bulkScreening,
          errorMessage: payload,
          currentScreeningState: BULK_SCREENING_FLOW.PROGRESS_ERROR
        }
      };
    case SET_SCREENING_PERCENT:
      return {
        ...state,
        bulkScreening: {
          ...state.bulkScreening,
          screeningPercent: payload
        }
      };
    case STOP_BULK_SCREENING:
      return {
        ...state,
        bulkScreening: {
          ...state.bulkScreening,
          stopScreeningCalled: true
        }
      };
    case STOP_BULK_SCREENING_SUCCESS:
      return {
        ...state,
        bulkScreening: {
          ...state.bulkScreening,
          ...(state.bulkScreening.currentScreeningState ===
          BULK_SCREENING_FLOW.SCREEN_SUCCESS
            ? {
                stopScreeningCalled: false
              }
            : {
                bulkScreeningStarted: false,
                isShowScanModal: false,
                isShowScreenModal: false,
                currentScreeningState: '',
                scannedData: [],
                invalidData: [],
                screeningPercent: 0,
                jobId: null
              })
        }
      };
    case STOP_BULK_SCREENING_FAIL:
      return {
        ...state,
        bulkScreening: {
          ...state.bulkScreening,
          stopScreeningCalled: false
        }
      };
    case GET_OD_NS_HISTORY_DOWNLOAD_CSV:
      return {
        ...state,
        alertHistory: {
          ...state.alertHistory,
          isLoading: true,
          hasError: false
        }
      };
    case RESET_OD_NS_HISTORY_DOWNLOAD_CSV:
      return {
        ...state,
        alertHistory: {
          csvData: null,
          isLoading: false,
          hasError: false
        }
      };
    case GET_OD_NS_HISTORY_DOWNLOAD_CSV_SUCCESS:
      return {
        ...state,
        alertHistory: {
          isLoading: false,
          hasError: false,
          csvData: {
            blob: payload?.blob,
            fileName: payload?.fileName
          }
        }
      };
    case GET_OD_NS_HISTORY_DOWNLOAD_CSV_FAIL:
      return {
        ...state,
        alertHistory: {
          isLoading: false,
          csvData: null,
          hasError: true
        }
      };
    case SELECTED_ALERT_IDS:
      return {
        ...state,
        alertList: {
          ...state.alertList,
          ...payload
        }
      };
    case SELECTED_ALERT_FILTERS:
      return {
        ...state,
        alertList: {
          ...state.alertList,
          filters: payload,
          selectedIds: [],
          selectedAlerts: [],
          currentPage: 1
        }
      };
    case FETCH_MATCHING_CONFIGS:
      return {
        ...state,
        matchingConfigs: {
          ...state.matchingConfigs,
          isLoading: true,
          hasError: false,
          data: []
        }
      };
    case FETCH_MATCHING_CONFIGS_SUCCESS:
      return {
        ...state,
        matchingConfigs: {
          ...state.matchingConfigs,
          isLoading: false,
          data: payload
        }
      };
    case FETCH_MATCHING_CONFIGS_FAIL:
      return {
        ...state,
        matchingConfigs: {
          ...state.matchingConfigs,
          isLoading: false,
          hasError: true,
          errorMessage: payload
        }
      };
    case NS_SEND_TO_CM_SUCCESS:
      return {
        ...state,
        alertList: {
          ...state.alertList,
          filters: {
            ...state.alertList.filters,
            refreshCount: payload.isFromAlertList
              ? state.alertList.filters.refreshCount + 1
              : state.alertList.filters.refreshCount
          },
          selectedIds: [],
          selectedAlerts: []
        }
      };
    case UPDATE_ALERT_LIST_PAGE:
      return {
        ...state,
        alertList: {
          ...state.alertList,
          currentPage: payload
        }
      };
    case UPDATE_ALERT_LIST_PAGE_SIZE:
      return {
        ...state,
        alertList: {
          ...state.alertList,
          pageSize: payload
        }
      };
    default:
      return state;
  }
}
